import React from 'react'
import ReactDOM from 'react-dom'
import UserConfirmation from './UserConfirmation'

const getUserConfirmation = (message, callback) => {
  const portal = document.createElement('div')
  document.body.appendChild(portal)
  const confirmAndUnmount = (answer) => {
    ReactDOM.unmountComponentAtNode(portal)
    document.body.removeChild(portal)
    callback(answer)
  }
  ReactDOM.render(
    <UserConfirmation
      message={message}
      onCancel={() => confirmAndUnmount(false)}
      onConfirm={() => confirmAndUnmount(true)}
    />,
    portal
  )
}

export default getUserConfirmation



// WEBPACK FOOTER //
// ./src/lib/getUserConfirmation.js